/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EnvironmentConfig } from '../models/config.model';
import { ServerPushModel } from '../models/server.model';
import { ConfigService } from './config.service';

/**
 * This service is provided to allow the UI to forward events to other connected clients.  These referenced API endpoints are typically used by other APIs, but can be invoked by the UI if the use case arises.
 */
@Injectable({
  providedIn: 'root'
})
export class ServerSendService {
  private http = inject(HttpClient);

  private config: EnvironmentConfig;
 
  constructor() {
    this.config = inject(ConfigService);
  }

  public sendToUser(targetUserGuid: string, payload: ServerPushModel) {
    return this.http.post<any>(`${this.config.sharedApiUrl}/push/user/${targetUserGuid}`, payload);
  }

  public sendToInternalUsers(payload: ServerPushModel) {
    return this.http.post<any>(`${this.config.sharedApiUrl}/push/internal`, payload);
  }

  public sendToExternalUsers(payload: ServerPushModel) {
    return this.http.post<any>(`${this.config.sharedApiUrl}/push/external`, payload);
  }

  public sendToDealer(acaDealerNumber: string, payload: ServerPushModel) {
    return this.http.post<any>(`${this.config.sharedApiUrl}/push/dealer/${acaDealerNumber}`, payload);
  }
}
